import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deal-invoice',
  templateUrl: './deal-invoice.component.html',
  styleUrls: ['./deal-invoice.component.scss']
})
export class DealInvoiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
